import gql from "graphql-tag";
export default gql`
  query($categoryID: String!) {
    cliparts: clipartsByCategory(categoryID: $categoryID) {
      id
      category {
        id
        title
      }
      file {
        id
        key
      }
    }
  }
`;
